<script>
import { Line, mixins } from 'vue-chartjs'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['options'],
  mounted () {
    this.loadColor()
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    loadColor() {
      this.gradient = this.$refs.canvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450)

      this.gradient2 = this.$refs.canvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450)

      this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)');
      this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
      this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
      
      this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)');
      this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
      this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');

      let gradients = [this.gradient, this.gradient2]
      for(let i = 0; i < this.chartData.datasets.length; i++) {
        this.chartData.datasets[i].backgroundColor = gradients[i % 2] 
      }
    }
  },
  watch: {
    chartData() {
      this.loadColor()
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>

<style>

</style>